var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMillstone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7071 21.2929C11.3166 21.6834 10.6834 21.6834 10.2929 21.2929L0.707107 11.7071C0.316583 11.3166 0.316581 10.6834 0.707107 10.2929L10.2929 0.707109C10.6834 0.316585 11.3166 0.316583 11.7071 0.707108L21.2929 10.2929C21.6834 10.6834 21.6834 11.3166 21.2929 11.7071L11.7071 21.2929Z",
    fill: "#2B2B32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMillstone);
export default __webpack_public_path__ + "static/media/Millstone.21d9d458.svg";
export { ForwardRef as ReactComponent };